import React from 'react';
import Header from '@components/Modals/Header';
import { CSVModalButton, CSVModalButtonRow } from '../../Buttons';
import Image from '@components/Image';
import styles from './Done.module.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { closeSettings } from '@repo/redux/actions/ui';
const csvImage = '/img/settings/csv-dark.png';
const csvImageLight = '/img/settings/csv-light.png';

export default function DoneView({
  close,
  forceDarkMode,
  groupID,
  isInOnboarding,
}: {
  close: () => void;
  forceDarkMode: boolean;
  groupID: string;
  isInOnboarding?: boolean;
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goToGroup = () => {
    close();
    dispatch(closeSettings);
    navigate(`/group/${groupID}`);
  };

  let copy =
    'Your CSV file is being imported, and your people should start appearing shortly. You can see the status of the import and everyone added by viewing the group below.';
  let btn = (
    <CSVModalButton onClick={goToGroup} block forceDarkMode={forceDarkMode}>
      View Group
    </CSVModalButton>
  );

  if (isInOnboarding) {
    copy =
      'Your CSV file is being imported, and your people should start appearing in Clay shortly.';
    btn = (
      <CSVModalButton onClick={close} block forceDarkMode={forceDarkMode}>
        Done
      </CSVModalButton>
    );
  }

  return (
    <>
      <Header.Plain onClose={close} />
      <div className={styles.doneView}>
        <Image
          className={styles.image}
          width={207}
          dark={csvImage}
          light={!forceDarkMode && csvImageLight}
        />
        <h3 className="text-default">You're all set!</h3>
        <p>{copy}</p>
        <CSVModalButtonRow vertical>{btn}</CSVModalButtonRow>
      </div>
    </>
  );
}
